import { render, staticRenderFns } from "./entities-card.vue?vue&type=template&id=309fe5e3&lang=html&"
import script from "./entities-card.vue?vue&type=script&lang=js&"
export * from "./entities-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports